import { createSelector } from 'reselect';

export const flightComparisonStateSelector = state => state.flightComparison;

export const flightComparisonDataSelector = createSelector(
  flightComparisonStateSelector,
  flightComparisonState => flightComparisonState.flightComparisonData
);

export const flightComparisonQuerySelector = createSelector(
  flightComparisonStateSelector,
  flightComparisonState => flightComparisonState.query
);

export const flightComparisonOmnitureInfoSelector = createSelector(
  flightComparisonStateSelector,
  flightComparisonState => flightComparisonState.flightComparisonOmnitureInfo
);

export const urlSearchParamSelector = createSelector(
  flightComparisonStateSelector,
  flightComparisonState => flightComparisonState.urlParams
);
